"use strict";Object.defineProperty(exports, "__esModule", {value: true});var t=(n=2)=>e=>typeof n=="function"?n(e):`${n*e}px`,r= exports.a =t;exports.a = r;
